<template>
<main id="invoice-page">
    <section>
        <article>

            <header>
                <div>
                    <h1>Invoice</h1>
                    <span>support@kolkin.com</span>
                </div>

                <button class="print-hide" v-if="invoice.allows_payment=='t'&&invoice.status!='8'" @click="$router.push({name:'invoice-payment',params:{number:invoice.invoice_serial_number}})">
                    Pay Invoice
                </button>

                <button class="print-hide" @click="printInvoice">
                    Print
                </button>

            </header>

            <div v-if="invoice.display_bank_info=='t'" class="invoice-info banking-info">
                <div class="left-side">
                    <div class="group">
                        <b>BILL FROM</b>
                        <p>Kolkin Corp</p>
                        <p>2211 Michelson Drive Suite 900</p>
                        <p>Irvine, CA 92612, USA</p>  
                        <p>(949) 877-0114</p>
                    </div>
                    <div class="group ach-info">
                        <b>ACH Payment</b>
                        <p><small>Account Name</small> <span>Kolkin Corporation</span></p>
                        <p><small>Routing Number</small> <span>121042882</span></p>
                        <p><small>Account Number</small> <span>{{ach_number}}</span></p>
                    </div>
                    
                </div>
                <div class="right-side">
                    <div id="bill-to-field" class="group">
                        <b>BILL TO</b>
                        <TextareaAutosize @blur.native="updateClientName" class="bill-to-input" v-model="invoice.client_name"></TextareaAutosize>
                    </div>
                    <div class="group">
                        <b>INVOICE ID</b>
                        <p>#{{invoice.invoice_serial_number}}</p>
                    </div>
                    <div class="group">
                        <b>INVOICE DATE</b>
                        <p>{{invoice.creation_formatted}}</p>
                    </div>
                    <div class="group">
                        <b>STATUS</b>
                        <p>{{invoiceStatus}}</p>
                    </div>
                </div>
            </div>

            <div v-if="invoice.display_bank_info!='t'" class="invoice-info">
                <div class="left-side">
                    <b>BILL FROM</b>
                    <p>Kolkin Corp</p>
                    <p>2211 Michelson Drive Suite 900</p>
                    <p>Irvine, CA 92612</p>  
                    <p>(949) 877-0114</p>
                </div>

                <div class="right-side" id="bill-to-field">
                    <b>BILL TO</b>
                    <TextareaAutosize @blur.native="updateClientName" class="bill-to-input" v-model="invoice.client_name"></TextareaAutosize>
                </div>

                
            </div>
            

            <div v-if="invoice.display_bank_info!='t'" class="invoice-info">
                <div class="left-side">
                    <b>INVOICE ID</b>
                    <p>#{{invoice.invoice_serial_number}}</p>
                </div>

                <div class="right-side">
                    <b>INVOICE DATE</b>
                    <p>{{invoice.creation_formatted}}</p>
                </div>
            </div>

            <div v-if="invoice.display_bank_info!='t'" class="invoice-info">
                <div class="left-side">
                    <b>STATUS</b>
                    <p>{{invoiceStatus}}</p>
                </div>

                <div class="right-side">
                    
                </div>
            </div>
            
            


            <div class="invoice-payment-info">
                <div>
                    <b>ITEM</b>
                    <b class="right">COST</b>
                </div>
                <div>
                    <div style="display: flex;  flex-direction: column;">
                        <span>{{invoice.title}}</span>
                        <small style="white-space: pre-wrap;">{{invoice.description}}</small>
                    </div>
                    <span class="right">${{numberWithCommas(invoice.amount)}}</span>
                </div>
                <div>
                    <span>Total:</span>
                    <span class="right">${{numberWithCommas(invoice.amount)}}</span>
                </div>
            </div>

        </article>
    </section>

    <Popper ref="billToInfo" target_id="bill-to-field" :append_to_body="true" :close_on_click_outside="false" placement="left">
        <div class="dropdown bill-to-dropdown">
            <p><b>Billing info is editable</b></p>
            <p>Click your info and type to make edits, including adding a VAT or a company name.</p>
            <button class="close" @click="closeBillToInfo">
                <i class="icon icon-close"></i>
            </button>
        </div>
        <slot name="arrow"><div class="bill-to-arrow"></div></slot>
    </Popper>
</main>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import store from "@/store";
import Utility from "@/mixins/Utility";
import axios from "axios";
import Popper from "@/../submodules/vue-base/components/Popper";
import Platform from "platform";

export default {

    name: "InvoicePage",

    components: {
        Popper
    },

    mixins: [
        Utility
    ],

    beforeRouteEnter(to, from, next) {
        store.dispatch("loadInvoice", to.params.number).then(function () {
            next();
        });

    },

    data(){
        return {
            ach_number: ""
        }
    },

    mounted(){
        if(Platform.os.family.includes("Android") || Platform.os.family.includes("iOS")){
            // We are mobile so we are not going to open the bill info message
        }else{
            this.$refs.billToInfo.toggle();
        }

        if(this.invoice.display_bank_info == "t"){
            axios.get("/api/invoice/ach", {
                params: {
                    number: this.invoice.invoice_serial_number
                }
            }).then(response => {
                console.log(response);
                this.ach_number = response.data.ach_number;
            }).catch(error => {
                console.log(error.response);
            });
        }
        
    },

    methods: {
        printInvoice(){
            this.$refs.billToInfo.close();
            setTimeout(function(){
                window.print();
            },20)
            
        },

        closeBillToInfo(){
            this.$refs.billToInfo.toggle();
        },

        updateClientName(){
            axios.put("/api/invoice", {
                invoice_id: this.invoice.invoice_id,
                client_name: this.invoice.client_name
            }).then(response => {
                console.log(response);
            }).catch(error => {
                console.log(error.response);
            });
        }
    },

    computed: {
        invoiceStatus(){
            var result = ""
            if(this.invoice.status == "8"){
                result = "Paid"
            }else if(this.invoice.status == "6" || this.invoice.status == "7"){
                result = "Pending"
            }else{
                result = "Incomplete"
            }
            return result;
        },
        ...mapGetters(["invoice"])
    }

}
</script>
